import { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";
import "./UploadReciept.scss";
import { useAppContext } from "../../../../../../../../Components/AppProvider";
import { setRedirect } from "../../../../../../utils/redirect";
export default function UploadReciept({
  setProgress,
  progress,
  selectedOrders,
  paymentMethod,
  paymentType,
  amountToPay,
  setOrderListUpdate,
}) {
  const {
    setUpdateOrderHistoryNav,
    customerId,
    addressId,
    setCountListUpdateById,
    customerEmail,
  } = useAppContext();
  const [preview, setPreview] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const ext = file.name.split(".").pop().toLowerCase();
    const supportedPreview = ["jpg", "jpeg", "png", "webp"].includes(ext);

    setSelectedFile(file);

    if (supportedPreview) {
      const reader = new FileReader();
      reader.onloadend = () => setPreview(reader.result);
      reader.readAsDataURL(file);
    } else {
      // fallback preview for HEIC/HEIF or unsupported types
      setPreview("/images/image-placeholder.png");
    }
  };

  const uploadPaymentDetails = async () => {
    if (!selectedFile) {
      alert("Please upload a receipt first.");
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("paymentMethod", paymentMethod);
      formData.append("paymentType", paymentType);
      formData.append("amount", amountToPay);
      formData.append("selectedOrders", JSON.stringify(selectedOrders));
      formData.append("receipt", selectedFile); // single file
      formData.append("addressId", addressId); // single file
      formData.append("email", customerEmail); // single file

      //console.log(selectedFile);

      const res = await fetch(
        `https://littlekidinside.shop/api/payments/payment`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (res.ok) {
        alert("Payment uploaded successfully!");
        setPreview(null);
        setSelectedFile(null);
        setProgress(progress + 1);
        setOrderListUpdate(true);
        setRedirect(1, 1);
        setUpdateOrderHistoryNav(true);
        setCountListUpdateById((p) => !p);
      } else {
        alert("Failed to upload payment.", res);
      }
    } catch (err) {
      console.error("Error saving product", err);
      alert("Error uploading payment:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="upload-modal-container">
      <h2>UPLOAD RECEIPT</h2>
      <span className="subject">Please upload receipt as proof of payment</span>

      <div
        className={`upload-panel-wrapper ${preview ? "hasUpload" : ""}`}
        style={!preview ? { minWidth: "330px" } : {}}
      >
        {preview && (
          <div className="preview-wrapper">
            <img src={preview} alt="Receipt Preview" />
          </div>
        )}

        <label className="upload-btn">
          <input
            type="file"
            accept="image/*,.heic,.heif,.webp,.jpg,.jpeg,.png"
            onChange={handleFileChange}
            hidden
          />
          <span>
            <FaPlus />
          </span>
          UPLOAD RECEIPT
        </label>

        <span>FILE EXTENSION: .JPG .JPEG .PNG</span>
      </div>

      <div className="action-button">
        <button
          className="cancel"
          onClick={() => setProgress(progress - 1)}
          disabled={loading}
        >
          BACK
        </button>
        <button
          className="proceed"
          onClick={uploadPaymentDetails}
          disabled={!preview || loading}
        >
          {loading ? "UPLOADING..." : "FINISH PAYMENT"}
        </button>
      </div>
    </div>
  );
}
